(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const Play = window.RB.Play;

  Object.assign(Play, {
    cardCost(state, iid, opts) {
      const c = Core.card(state, iid);
      opts = opts || {};
      const cost = {
        energy: c.energy || 0,
        pips: [],
        anyPower: 0,
      };
      const pipDomains = Core.pipDomains(c.domains);
      const nPips = c.power || 0;
      for (let i = 0; i < nPips; i++) cost.pips.push(pipDomains);
      if (opts.accelerate) {
        cost.energy += 1;
        cost.pips.push(pipDomains);
      }
      if (opts.ignoreBase) {
        cost.energy = opts.accelerate ? 1 : 0;
        cost.pips = opts.accelerate ? [pipDomains] : [];
      }
      if (opts.deflectCount) cost.anyPower += opts.deflectCount;

      if (opts.waiveAll) {
        cost.energy = 0;
        cost.pips = [];
        cost.anyPower = 0;
      } else if (opts.waiveEnergy) {
        cost.energy = 0;
      }
      if (opts.energyLess) cost.energy = Math.max(0, cost.energy - opts.energyLess);
      if (opts.controller !== undefined) {
        for (const m of Play.nextPlayModsFor(state, opts.controller, iid, "costLess")) {
          cost.energy = Math.max(0, cost.energy - m.n);
          for (let i = 0; i < (m.power || 0); i++) Play.discountRainbow(cost);
        }
        for (const m of Play.nextPlayModsFor(state, opts.controller, iid, "costMore")) {
          cost.energy += m.n;
          cost.anyPower += m.power || 0;
        }
      }
      const script = RB.Scripts.forCard(state, iid);
      if (script && script.costMod && opts.controller !== undefined) {
        const cm = script.costMod;
        const ctl = opts.controller;
        if (cm.k === "legion" && state.turnFacts.players[ctl].played >= 1) {
          cost.energy = Math.max(0, cost.energy - (cm.energyLess || 0));
        }
        if (cm.k === "perTrash") {
          cost.energy = Math.max(cm.min || 0, cost.energy - state.players[ctl].trash.length * (cm.each || 1));
        }
        if (cm.k === "highestFriendlyMight") {
          let hi = 0;
          for (const bIid of Core.boardObjs(state)) {
            const bo = state.objs[bIid];
            if (bo.controller !== ctl || !Core.isType(state, bIid, "unit")) continue;
            hi = Math.max(hi, Core.effMight(state, bIid) || 0);
          }
          cost.energy = Math.max(cm.min || 0, cost.energy - hi);
        }
        if (cm.k === "enemyDiedThisTurn" && state.turnFacts.players[Core.otherPlayer(ctl)].enemyDied) {
          cost.energy = Math.max(cm.min || 0, cost.energy - (cm.energyLess || 0));
        }
        if (cm.k === "oppNearWin") {
          const opp2 = Core.otherPlayer(ctl);
          if (state.players[opp2].points >= Core.victoryScore(state) - (cm.within || 3)) {
            cost.energy = Math.max(cm.min || 0, cost.energy - (cm.energyLess || 0));
          }
        }
      }
      if (opts.controller !== undefined) {
        for (const m of Play.costModsFor(state, iid, opts.controller, opts.item, opts.fromZone)) {
          Play.applyCostMod(state, cost, m, iid, opts.controller);
        }
      }
      if (opts.controller !== undefined && Core.isType(state, iid, "unit")) {
        for (const s of Core.ruleSources(state, "unitCostMod", { controller: opts.controller })) {
          const um = s.rule;
          if (um.tag && !Core.hasTag(state, iid, um.tag)) continue;
          cost.energy = Math.max(um.min !== undefined ? um.min : 0, cost.energy - (um.less || 0));
        }
      }
      if (opts.controller !== undefined && Core.isType(state, iid, "spell")) {
        for (const s of Core.ruleSources(state, "spellCostMod", { controller: opts.controller })) {
          const mod = s.rule;
          if (mod.whileAtBf && (!s.obj.loc || s.obj.loc.t !== "bf")) continue;
          cost.energy = Math.max(mod.min !== undefined ? mod.min : 0, cost.energy - (mod.less || 0));
        }
      }
      return cost;
    },

    costModTargetsMatch(state, m, item, srcIid) {
      const want = m.targetsMatching;
      if (!want) return true;
      if (!item) return false;
      const spec = {};
      for (const k in want) if (k !== "atSourceBf") spec[k] = want[k];
      const all = [];
      for (const b in item.targets) for (const t of item.targets[b]) all.push(t);
      if (!all.length) return false;
      const pool = RB.Play.candidates(state, Object.assign({ ignoreUntargetable: true }, spec), item);
      return all.some(function (t) {
        if (pool.indexOf(t) < 0) return false;
        if (want.atSourceBf) {
          const o = state.objs[t];
          if (!(o && o.loc && o.loc.t === "bf" && o.loc.iid === srcIid)) return false;
        }
        return true;
      });
    },

    costModMatches(state, m, iid, ctl, srcIid, srcObj, item, fromZone) {
      const what = m.what || {};
      if (m.fromZone !== undefined) {
        const z = fromZone || "hand";
        if (m.fromZone === "notHand") { if (z === "hand") return false; }
        else if (Array.isArray(m.fromZone)) { if (m.fromZone.indexOf(z) < 0) return false; }
        else if (m.fromZone !== z) return false;
      }
      if (what.type && !Core.isType(state, iid, what.type)) return false;
      if (what.notType && Core.isType(state, iid, what.notType)) return false;
      if (what.tag && !Core.hasTag(state, iid, what.tag)) return false;
      if (what.hasKw && !Core.hasKw(state, iid, what.hasKw) &&
        !(what.orFromFacedown && (fromZone || "hand") === "facedown")) return false;
      if (what.token && !(state.objs[iid] || {}).token) return false;
      if (what.nonToken && (state.objs[iid] || {}).token) return false;
      if (what.maxEnergy !== undefined && (Core.card(state, iid).energy || 0) > what.maxEnergy) return false;
      if (srcIid !== undefined) {
        const who = m.who || "friendly";
        const owner = srcObj ? srcObj.controller : ctl;
        if (who === "friendly" && owner !== ctl) return false;
        if (who === "enemy" && owner === ctl) return false;
      }
      if (m.cond && !RB.Scripts.staticCond(state, srcIid === undefined ? iid : srcIid,
        srcIid === undefined ? ctl : (srcObj ? srcObj.controller : ctl), m.cond)) return false;
      if (m.targetsMatching && !Play.costModTargetsMatch(state, m, item, srcIid)) return false;
      return true;
    },

    costModAmount(state, m, key, iid, ctl) {
      const v = m[key];
      if (v === undefined) return 0;
      if (typeof v === "number") return v;
      const item = { controller: ctl, source: iid, iid: iid, targets: {}, vars: {}, ctx: {} };
      return RB.FX.amount(state, item, v);
    },

    applyCostMod(state, cost, m, iid, ctl) {
      const less = Play.costModAmount(state, m, "energyLess", iid, ctl);
      const more = Play.costModAmount(state, m, "energyMore", iid, ctl);
      const floor = m.min !== undefined ? m.min : 0;
      if (less) cost.energy = Math.max(Math.min(floor, cost.energy), cost.energy - less);
      if (more) cost.energy += more;
      const powerLess = Play.costModAmount(state, m, "powerLess", iid, ctl);
      for (let i = 0; i < powerLess; i++) Play.discountRainbow(cost);
      const powerMore = Play.costModAmount(state, m, "powerMore", iid, ctl);
      if (powerMore) cost.anyPower += powerMore;
      const either = Play.costModAmount(state, m, "energyOrPowerLess", iid, ctl);
      for (let i = 0; i < either; i++) {
        if (cost.energy > floor) cost.energy -= 1;
        else if (cost.anyPower > 0) cost.anyPower -= 1;
        else if (cost.pips.length) cost.pips.pop();
      }
      const eitherMore = Play.costModAmount(state, m, "energyOrPowerMore", iid, ctl);
      if (eitherMore) cost.energy += eitherMore;
    },

    costModsFor(state, iid, ctl, item, fromZone) {
      const out = [];
      const own = RB.Scripts.forCard(state, iid);
      if (own && own.costMods) {
        for (const m of own.costMods) {
          if (Play.costModMatches(state, m, iid, ctl, undefined, undefined, item, fromZone)) out.push(m);
        }
      }
      for (const s of Core.ruleSources(state, "auraCostMod", { legends: true })) {
        const so = s.obj;
        for (const m of s.rule) {
          if (m.repeat || m.addCost || m.ability) continue;
          if (m.requiresControl && so.controller !== ctl) continue;
          if (m.whileAtBf && !(so.loc && so.loc.t === "bf")) continue;
          if (Play.costModMatches(state, m, iid, ctl, s.iid, so, item, fromZone)) out.push(m);
        }
      }
      return out;
    },

    repeatCostsFor(state, item) {
      const iid = item.iid;
      const p = item.controller;
      const own = RB.Scripts.forCard(state, iid);
      const out = ((own && own.repeatCosts) || []).slice();
      if (!Core.isType(state, iid, "spell")) return out;
      for (const s of Core.ruleSources(state, "auraRepeatCosts", { legends: true })) {
        for (const r of s.rule) {
          if (RB.Scripts.auraMatch(state, r, s.iid, s.obj, iid, null, { p: p, loc: null })) out.push(r);
        }
      }
      for (const m of Play.nextPlayModsFor(state, p, iid, "grantRepeat")) {
        out.push({ costOf: m.repeatOf || "base", granted: true });
      }
      return out;
    },

    repeatEntryCost(state, item, entry) {
      const c = Core.card(state, item.iid);
      const doms = c.domains;
      if (!entry.costOf) return Play.costFromRes(entry.cost, doms);
      if (entry.costOf === "current") {
        const cur = Play.cardCost(state, item.iid, {
          item: item, fromZone: item.fromZone || "hand", controller: item.controller,
        });
        return { energy: cur.energy, pips: cur.pips.slice(), anyPower: cur.anyPower };
      }
      return Play.costFromRes({ energy: c.energy || 0, pips: c.power || 0 }, doms);
    },

    auraCostModsFlagged(state, ctl, flag) {
      const out = [];
      for (const s of Core.ruleSources(state, "auraCostMod", { legends: true })) {
        for (const m of s.rule) {
          if (!m[flag]) continue;
          if (!RB.Scripts.auraMatch(state, m, s.iid, s.obj, null, null, { p: ctl, loc: null })) continue;
          out.push(m);
        }
      }
      return out;
    },

    abilityCostMods(state, srcIid, ctl, ability) {
      const out = [];
      const owner = state.objs[srcIid];
      if (!owner) return out;
      for (const s of Core.ruleSources(state, "auraCostMod", { legends: true })) {
        const so = s.obj;
        for (const m of s.rule) {
          const ab = m.ability;
          if (!ab) continue;
          if (m.requiresControl && so.controller !== ctl) continue;
          const who = m.who || "friendly";
          if (who === "friendly" && owner.controller !== so.controller) continue;
          if (who === "enemy" && owner.controller === so.controller) continue;
          if (ab.self && srcIid !== s.iid) continue;
          if (ab.label && ability.label !== ab.label) continue;
          if (ab.type && !Core.isType(state, srcIid, ab.type)) continue;
          if (ab.tag && !Core.hasTag(state, srcIid, ab.tag)) continue;
          if (ab.atSourceBf && !(owner.loc && owner.loc.t === "bf" && owner.loc.iid === s.iid)) continue;
          if (m.cond && !RB.Scripts.staticCond(state, s.iid, so.controller, m.cond)) continue;
          out.push(m);
        }
      }
      return out;
    },

    costFromRes(res, cardDomains) {
      res = res || { energy: 0, pips: 0, anyPower: 0, domains: null };
      const cost = { energy: res.energy || 0, pips: [], anyPower: res.anyPower || 0 };
      const doms = res.domains || Core.pipDomains(cardDomains);
      for (let i = 0; i < (res.pips || 0); i++) cost.pips.push(doms);
      return cost;
    },

    discountRainbow(cost) {
      if (cost.anyPower > 0) cost.anyPower -= 1;
      else if (cost.pips.length) cost.pips.pop();
      return cost;
    },

    auraFlagSources(state, p, key) {
      const out = [];
      for (const s of Core.ruleSources(state, key, { legends: true, controller: p })) {
        if (s.rule.requiresEmpowered && !s.obj.empowered) continue;
        if (s.rule.cond && !RB.Scripts.staticCond(state, s.iid, p, s.rule.cond)) continue;
        out.push(s.rule);
      }
      return out;
    },

    uncounterableFor(state, p) {
      return Play.auraFlagSources(state, p, "auraUncounterable").length > 0;
    },

    minusMightBonus(state, p) {
      let n = 0;
      for (const r of Play.auraFlagSources(state, p, "auraMinusMightBonus")) n += r.n || 1;
      return n;
    },

    trashPlayAllowed(state, p, iid) {
      return Core.effectSources(state, { battlefields: false }).some(function (s2) {
        const so = state.objs[s2];
        if (!so || so.attachedTo || so.controller !== p) return false;
        const sc = RB.Scripts.forCard(state, s2);
        return !!(sc && sc.allowTrashPlay);
      });
    },

    flowGrant(state, iid) {
      const o = state.objs[iid];
      for (const g of (o && o.grants) || []) if (g.k === "flowCost") return g;
      return null;
    },

    flowCardCost(state, iid) {
      const script = RB.Scripts.forCard(state, iid);
      const c = Core.card(state, iid);
      const grant = Play.flowGrant(state, iid);
      if (grant) return Play.costFromRes(grant.cost, c && c.domains);
      return Play.costFromRes(script && script.flowCost, c && c.domains);
    },

    deflectSurcharge(state, controller, targetIids) {
      let n = 0;
      for (const t of targetIids || []) {
        const o = state.objs[t];
        if (o && o.zone === "board" && o.controller !== controller) {
          if (Play.deflectSuppressed(state, o)) continue;
          n += Core.kwVal(state, t, "deflect");
        }
      }
      return n;
    },

    deflectSuppressed(state, o) {
      if (!o.loc || o.loc.t !== "bf") return false;
      const bs = RB.Scripts.forCard(state, o.loc.iid);
      return !!(bs && bs.suppressDeflectHere);
    },

    restrictedUsable(pool, ctx) {
      return !!(pool.r && ctx && ctx[pool.r.tag]);
    },

    mergedPool(pool, ctx) {
      const eff = { energy: pool.energy, power: {} };
      for (const d in pool.power) eff.power[d] = pool.power[d];
      if (Play.restrictedUsable(pool, ctx)) {
        eff.energy += pool.r.energy;
        for (const d in pool.r.power) eff.power[d] += pool.r.power[d];
      }
      return eff;
    },

    payCtxForCard(state, iid) {
      return {
        spell: Core.isType(state, iid, "spell"),
        gear: Core.isType(state, iid, "gear"),
        unit: Core.isType(state, iid, "unit"),
        showdown: !!state.showdown,
      };
    },

    payCtxForItem(state, item) {
      if (item.kind === "ability") {
        return {
          spell: false,
          gear: !!(item.source && Core.isType(state, item.source, "gear")),
          unit: !!(item.source && Core.isType(state, item.source, "unit")),
          showdown: !!state.showdown,
        };
      }
      if (item.iid) return Play.payCtxForCard(state, item.iid);
      return {};
    },

    poolShortfall(pool, cost, ctx) {
      pool = Play.mergedPool(pool, ctx);
      if (pool.energy < cost.energy) return { kind: "energy", need: cost.energy, have: pool.energy };
      const power = {};
      for (const d in pool.power) power[d] = pool.power[d];
      let anyNeeded = 0;
      let openPips = cost.anyPower;
      let unpaid = null;
      for (const pip of cost.pips) {
        if (!pip) { openPips++; continue; }
        let paid = false;
        for (const d of pip) {
          if (power[d] > 0) { power[d]--; paid = true; break; }
        }
        if (!paid) { anyNeeded++; (unpaid || (unpaid = [])).push(pip); }
      }
      if (power.any < anyNeeded) return { kind: "domain", pips: unpaid, need: anyNeeded, have: power.any };
      power.any -= anyNeeded;
      let loose = power.any;
      for (const d of Core.DOMAINS) loose += power[d];
      if (loose < openPips) return { kind: "power", need: openPips, have: loose };
      return null;
    },

    poolCovers(pool, cost, ctx) {
      return !Play.poolShortfall(pool, cost, ctx);
    },

    domainLabel(d) {
      if (d === "any") return "any-domain";
      return d.charAt(0).toUpperCase() + d.slice(1);
    },

    costText(cost) {
      const bits = [];
      if (cost.energy) bits.push(cost.energy + " energy");
      const pips = {};
      let open = 0;
      for (const pip of cost.pips || []) {
        if (!pip) { open++; continue; }
        const key = pip.map(Play.domainLabel).join("/");
        pips[key] = (pips[key] || 0) + 1;
      }
      for (const key in pips) bits.push(pips[key] + " " + key + " power");
      open += cost.anyPower || 0;
      if (open) bits.push(open + " power of any domain");
      return bits.length ? bits.join(" + ") : "nothing";
    },

    spendCost(state, p, cost, ctx) {
      const real = state.players[p].pool;
      const buckets = Play.restrictedUsable(real, ctx) ? [real.r, real] : [real];
      const has = function (kind) {
        return buckets.some(function (b) { return (kind === "energy" ? b.energy : b.power[kind]) > 0; });
      };
      const take = function (kind) {
        for (const b of buckets) {
          if (kind === "energy") { if (b.energy > 0) { b.energy--; return true; } }
          else if (b.power[kind] > 0) { b.power[kind]--; return true; }
        }
        return false;
      };
      const takeFirst = function (kinds) {
        for (const k of kinds) if (has(k)) return take(k);
        return false;
      };
      for (let i = 0; i < cost.energy; i++) {
        if (!take("energy")) throw new Error("cannot pay energy");
      }
      const orderedPips = cost.pips.filter(function (p2) { return p2; })
        .concat(cost.pips.filter(function (p2) { return !p2; }));
      for (const pip of orderedPips) {
        const paid = pip ? takeFirst(pip.concat(["any"])) : takeFirst(["any"].concat(Core.DOMAINS));
        if (!paid) throw new Error("cannot pay pip");
      }
      for (let i = 0; i < cost.anyPower; i++) {
        if (!takeFirst(["any"].concat(Core.DOMAINS))) throw new Error("cannot pay any-power");
      }
      if (real.r) {
        let rLeft = real.r.energy;
        for (const d in real.r.power) rLeft += real.r.power[d] || 0;
        if (!rLeft) real.r = null;
      }
      const facts = state.turnFacts && state.turnFacts.players[p];
      if (facts) {
        const power = cost.pips.length + cost.anyPower;
        facts.spentEnergy += cost.energy;
        facts.spentPower += power;
        if (ctx && ctx.spell) {
          facts.maxSpellEnergy = Math.max(facts.maxSpellEnergy, cost.energy);
          facts.lastSpellEnergy = cost.energy;
        }
      }
    },

    runActivation(state, p, act) {
      const o = state.objs[act.iid];
      if (!o) return "no such object";
      const pool = state.players[p].pool;
      if (act.mode === "exhaustRune") {
        if (!Core.isType(state, act.iid, "rune") || o.zone !== "board" || o.controller !== p) return "not your board rune";
        if (!o.ready) return "rune exhausted";
        o.ready = false;
        pool.energy += 1;
        RB.FX.emit(state, { type: "runeExhausted", iid: act.iid, player: p });
        return null;
      }
      if (act.mode === "recycleRune") {
        if (!Core.isType(state, act.iid, "rune") || o.zone !== "board" || o.controller !== p) return "not your board rune";
        const dom = Play.runeDomain(state, act.iid);
        Flow.recycleCards(state, [act.iid]);
        pool.power[dom] += 1;
        return null;
      }
      if (act.mode === "legend") {
        if (o.iid !== state.players[p].legendIid) return "not your legend";
        if (!o.ready) return "legend exhausted";
        const spec = RB.Scripts.legendAdd(state, act.iid);
        if (!spec) return "legend has no known add ability";
        o.ready = false;
        Play.gainSpec(Play.restrictedBucket(pool, spec.only), spec);
        return null;
      }
      return "unknown activation";
    },

    restrictedBucket(pool, tag) {
      if (!tag || (pool.r && pool.r.tag !== tag)) return pool;
      if (!pool.r) pool.r = { tag: tag, energy: 0, power: Core.emptyPool().power };
      return pool.r;
    },

    gainSpec(target, spec) {
      if (spec.energy) target.energy += spec.energy;
      if (spec.anyPower) target.power.any += spec.anyPower;
      if (spec.domain) target.power[spec.domain] += 1;
    },

    legendGain(state, p, ctx) {
      const legend = state.objs[state.players[p].legendIid];
      if (!legend.ready) return null;
      const spec = RB.Scripts.legendAdd(state, legend.iid);
      return spec && (!spec.only || (ctx && ctx[spec.only])) ? spec : null;
    },

    potentialPool(state, p, ctx, detail) {
      const pool = Play.mergedPool(state.players[p].pool, ctx);
      const seen = detail ? { ready: 0, exhausted: 0, domains: {} } : null;
      for (const iid of Core.runesOf(state, p)) {
        const o = state.objs[iid];
        if (o.ready) pool.energy += 1;
        const dom = Play.runeDomain(state, iid);
        pool.power[dom] += 1;
        if (seen) {
          if (o.ready) {
            seen.ready++;
            seen.domains[dom] = (seen.domains[dom] || 0) + 1;
          } else {
            seen.exhausted++;
          }
        }
      }
      const spec = Play.legendGain(state, p, ctx);
      if (spec) Play.gainSpec(pool, spec);
      return detail ? { pool: pool, runes: seen } : pool;
    },

    poolPotentialCovers(state, p, cost, ctx) {
      return !Play.poolShortfall(Play.potentialPool(state, p, ctx), cost);
    },

    purseText(runes) {
      if (!runes.ready && !runes.exhausted) return "you have no runes in play";
      if (!runes.ready) return "all " + runes.exhausted + " of your runes are already exhausted";
      const by = [];
      for (const d in runes.domains) by.push(runes.domains[d] + " " + Play.domainLabel(d));
      return "you have " + runes.ready + " ready rune" + (runes.ready === 1 ? "" : "s") +
        (by.length ? " (" + by.join(", ") + ")" : "") +
        (runes.exhausted ? " and " + runes.exhausted + " exhausted" : "");
    },

    shortfallText(state, p, cost, ctx) {
      const detail = Play.potentialPool(state, p, ctx, true);
      const gap = Play.poolShortfall(detail.pool, cost);
      if (!gap) return null;
      const purse = Play.purseText(detail.runes);
      if (gap.kind === "energy") return "you can raise only " + gap.have + " energy - " + purse;
      if (gap.kind === "domain") {
        const want = {};
        for (const pip of gap.pips || []) want[pip.map(Play.domainLabel).join(" or ")] = 1;
        return "you have no " + Object.keys(want).join(" and no ") + " power to spare - " + purse;
      }
      return "you can raise only " + gap.have + " power in total - " + purse;
    },

    hideCosts(state, p) {
      if (state.turnFacts.players[p].freeHides) return [{ energy: 0, pips: [], anyPower: 0 }];
      const out = [{ energy: 0, pips: [], anyPower: 1 }];
      for (const s of Core.ruleSources(state, "hideEnergyAlt", { legends: true, controller: p })) {
        out.push({ energy: s.rule, pips: [], anyPower: 0 });
      }
      return out;
    },

    maxAffordableEnergy(state, p) {
      let n = 0;
      while (n < 30 && Play.poolPotentialCovers(state, p, { energy: n + 1, pips: [], anyPower: 0 }, {})) n++;
      return n;
    },

    maxAffordablePower(state, p) {
      let n = 0;
      while (n < 30 && Play.poolPotentialCovers(state, p, { energy: 0, pips: [], anyPower: n + 1 }, {})) n++;
      return n;
    },

    runeDomain(state, iid) {
      const doms = Core.pipDomains(Core.card(state, iid).domains);
      return doms ? doms[0] : "any";
    },

    payActRank(act) {
      return act.mode === "exhaustRune" ? 0 : act.mode === "recycleRune" ? 1 : 2;
    },

    orderPayActs(acts) {
      return (acts || []).slice().sort(function (a, b) {
        return Play.payActRank(a) - Play.payActRank(b);
      });
    },

    payActLegal(state, p, act, prior) {
      const o = state.objs[act.iid];
      if (!o) return false;
      for (const x of prior || []) if (x.iid === act.iid && x.mode === act.mode) return false;
      if (act.mode === "exhaustRune" || act.mode === "recycleRune") {
        if (!Core.isType(state, act.iid, "rune") || o.zone !== "board" || o.controller !== p) return false;
        return act.mode === "recycleRune" || !!o.ready;
      }
      if (act.mode === "legend") {
        return act.iid === state.players[p].legendIid && !!o.ready && !!RB.Scripts.legendAdd(state, act.iid);
      }
      return false;
    },

    payActGain(state, p, act, ctx) {
      if (act.mode === "exhaustRune") return { energy: 1 };
      if (act.mode === "recycleRune") return { domain: Play.runeDomain(state, act.iid) };
      if (act.mode === "legend") {
        const spec = RB.Scripts.legendAdd(state, act.iid);
        if (!spec) return null;
        if (spec.only && !(ctx && ctx[spec.only])) return null;
        return spec;
      }
      return null;
    },

    poolAfterActs(state, p, acts, ctx) {
      const pool = Play.mergedPool(state.players[p].pool, ctx);
      for (const act of acts || []) {
        const gain = Play.payActGain(state, p, act, ctx);
        if (gain) Play.gainSpec(pool, gain);
      }
      return pool;
    },

    payActSources(state, p, ctx) {
      const out = [];
      for (const iid of Core.runesOf(state, p)) {
        out.push({ iid: iid, kind: "rune", domain: Play.runeDomain(state, iid), ready: !!state.objs[iid].ready });
      }
      const legendIid = state.players[p].legendIid;
      const spec = RB.Scripts.legendAdd(state, legendIid);
      if (spec && (!spec.only || (ctx && ctx[spec.only]))) {
        out.push({ iid: legendIid, kind: "legend", ready: !!state.objs[legendIid].ready, spec: spec });
      }
      return out;
    },

    autoPayPlan(state, p, cost, ctx) {
      const pool = Play.mergedPool(state.players[p].pool, ctx);
      const acts = [];
      const runes = Core.runesOf(state, p);
      const domainOf = function (iid) { return Play.runeDomain(state, iid); };
      const allowed = {};
      for (const pip of cost.pips) {
        if (pip) for (const d of pip) allowed[d] = true;
      }
      const openTotal = cost.pips.filter(function (x) { return !x; }).length + cost.anyPower;

      const needs = function () {
        const power = {};
        for (const d in pool.power) power[d] = pool.power[d];
        let rm = 0;
        for (const pip of cost.pips) {
          if (!pip) continue;
          let paid = false;
          for (const d of pip) {
            if (power[d] > 0) { power[d]--; paid = true; break; }
          }
          if (!paid) rm++;
        }
        const useAny = Math.min(power.any, rm);
        rm -= useAny;
        power.any -= useAny;
        let loose = power.any;
        for (const d of Core.DOMAINS) loose += power[d];
        return { rm: rm, om: Math.max(0, openTotal - loose), e: Math.max(0, cost.energy - pool.energy) };
      };

      const recycles = [];
      const unused = function (iid) {
        return !recycles.some(function (x) { return x.iid === iid; });
      };
      const sorted = runes.slice().sort(function (a, b) {
        const ar = state.objs[a].ready ? 1 : 0;
        const br = state.objs[b].ready ? 1 : 0;
        return ar - br;
      });

      const pickRune = function (wantAllowed) {
        for (const iid of sorted) {
          if (!unused(iid)) continue;
          if (!!allowed[domainOf(iid)] !== wantAllowed) continue;
          return iid;
        }
        return null;
      };
      let guard = 0;
      while (guard++ < 40) {
        const n = needs();
        if (n.rm <= 0 && n.om <= 0) break;
        let pickIid = n.rm > 0 ? pickRune(true) : null;
        if (!pickIid && n.om > 0) pickIid = pickRune(false) || pickRune(true);
        if (!pickIid) break;
        recycles.push({ iid: pickIid, mode: "recycleRune" });
        pool.power[domainOf(pickIid)] += 1;
      }

      const exhausts = [];
      const exhaustFor = function (iid) {
        if (needs().e <= 0 || !state.objs[iid].ready) return false;
        if (exhausts.some(function (x) { return x.iid === iid; })) return false;
        exhausts.push({ iid: iid, mode: "exhaustRune" });
        pool.energy += 1;
        return true;
      };
      for (const act of recycles) exhaustFor(act.iid);
      for (const iid of runes) exhaustFor(iid);
      for (const act of exhausts) acts.push(act);
      for (const act of recycles) acts.push(act);

      const n2 = needs();
      if (n2.e > 0 || n2.rm > 0 || n2.om > 0) {
        const spec = Play.legendGain(state, p, ctx);
        if (spec) {
          acts.push({ iid: state.players[p].legendIid, mode: "legend" });
          Play.gainSpec(pool, spec);
        }
      }
      if (!Play.poolCovers(pool, cost)) return null;
      return acts;
    },
  });
})();
